import { CompanyInvitationsManageContent } from "../../features/companyWorkspace";

function CompanyInvitationsManageScreen() {
  return <CompanyInvitationsManageContent />;
}

export default CompanyInvitationsManageScreen;
